/********************************************************************************
 * COMPONENT: CHECKOTUT FORM
 * ------------------------------------------------------------------------------
 *
 * *****************************************************************************/

import React, { useState, useEffect } from 'react';

import { Stack } from '@mui/material';
import { Flavors, Protein, Prices, CheckoutButton } from './components';
import { SanityCheckoutForm } from 'src/types/sanity/types.checkoutForm';
import { useEnvironment } from 'src/components/hooks';

// POSTHOG TRACKING
import posthog from 'posthog-js';

interface CheckoutFormProps {
  value: SanityCheckoutForm;
}

const CheckoutForm = ({ value }: CheckoutFormProps) => {
  const [flavorSelection, setFlavorSelection] = useState<string | null>(null);
  const [proteinSelection, setProteinSelection] = useState<string | null>(null);
  const [priceId, setPriceId] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  if (!value.product) return null;

  /********************************************************************************
   * * FUNCTION: GET PRODUCT ID
   * ------------------------------------------------------------------------------
   * The puprose of this is to return the product ID based on the environment.
   * *****************************************************************************/
  // * Determine the dev environment using the useEnvironment hook
  const { useDev } = useEnvironment();

  // * Find the product ID based on the environment
  const productId = value.product.productId.find(product => product.environment === (useDev ? 'development' : 'production'))?.productId ?? '';
  const anonymousId = posthog.get_distinct_id();

  useEffect(() => {

    posthog.capture('assessment summary viewed', { 
      anonymous_id: anonymousId,
      product_id: productId,
      product_slug: value.product.eloProductSlug ?? ''
     });

  },[productId, anonymousId]);


  return (
    <>
      <Stack spacing={4} width={'100%'} py={['1.47rem']} px={['.47rem']}>
        <Flavors flavors={value.product.flavor} get={flavorSelection} set={setFlavorSelection} />
        <Protein protein={value.product.protein} get={proteinSelection} set={setProteinSelection} />
        <Prices prices={value.product.prices} get={priceId} set={setPriceId} />
        <CheckoutButton
          label="Checkout →"
          productId={productId}
          flavorSelection={flavorSelection}
          proteinSelection={proteinSelection}
          priceSelection={priceId}
          error={error}
          setError={setError}
          successUrl={value?.successPage?.slug?.current ?? '/'}
          eloProductSlug={value.product.eloProductSlug ?? ''}
        />
      </Stack>
    </>
  );
};

export default CheckoutForm;
